import { Card, CardContent } from "@/components/ui/card";
import { getOccupationGroupContent } from "@/lib/occupationContent";

interface OccupationIntroProps {
  occupationTitle: string;
  locationName: string;
  description?: string;
  socCode?: string;
}

/**
 * Dynamic introduction text for occupation pages
 * Provides unique, SEO-friendly content for each occupation/location combination
 */
export default function OccupationIntro({ 
  occupationTitle, 
  locationName,
  description,
  socCode,
}: OccupationIntroProps) {
  const group = getOccupationGroupContent(socCode);
  // Generate contextual intro based on occupation family and location
  const introText = description ||
    `This page shows employer-reported wages for ${occupationTitle} in ${locationName}, drawn from the ` +
    `Bureau of Labor Statistics OEWS survey — median and mean pay, the full percentile distribution, ` +
    `and the industries that employ this occupation locally. ${group.payDrivers}`;

  return (
    <Card className="mb-6">
      <CardContent className="pt-6">
        <p className="text-muted-foreground leading-relaxed">
          {introText}
        </p>
      </CardContent>
    </Card>
  );
}

